// extracted by mini-css-extract-plugin
export default {"button":"ProjectList_button__3C9EC","imageContainer":"ProjectList_imageContainer__0iR8p","image":"ProjectList_image__caw3e"};